<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <div class="months">配置月份<el-date-picker type="month" placeholder="选择日期" value-format="yyyy-MM" :clearable="false" v-model="form.dataMonth" @change="onChange" class="ml20"></el-date-picker>
          </div>  
          <el-row>
            <el-col :span="12"><p class="order-title-boxs"><span class="blueBlock"></span><i>门店总业绩({{form.shopAchAmount}})</i></p></el-col>
            <el-col :span="12" class="dates pr16"><div class="flex-row end jishi"><p class="staff-names cur" @click="addStaff('shop')">{{ staffNames}}</p>&nbsp;
            <el-icon name="arrow-down" /></div></el-col>
          </el-row>
          <el-row class="plr16">
            <el-col :span="12" class="itemCol mb10" v-for="item in form.shopAchAmountList" :key="item.staffId">
              <div class="itemCol-name">{{item.staffName}}</div>
              <el-input class="ey" v-model="item.saleTarget" @input="keyUp(item,1)" placeholder="请输入目标" maxlength="8" />
            </el-col>
          </el-row>
          <el-row class="staff-boxs">
            <el-row>
              <el-col :span="12"><p class="order-title-boxs"><span class="blueBlock"></span><i>产品总业绩({{form.productAchAmount}})</i></p></el-col>
              <el-col :span="12" class="dates pr16"><div class="flex-row end jishi"><p class="staff-names cur" @click="addStaff('product')">{{ staffNames}}</p>&nbsp;
              <el-icon name="arrow-down" /></div></el-col>
            </el-row>
            <el-row class="plr16">
              <el-col :span="12" class="itemCol mb10" v-for="item in form.productAchAmountList" :key="item.staffId">
                  <div class="itemCol-name">{{item.staffName}}</div>
                  <el-input class="ey" v-model="item.saleTarget" @input="keyUp(item,2)" maxlength="8" placeholder="请输入目标" />
              </el-col>
            </el-row>
          </el-row>
          <el-row class="staff-boxs">
            <el-row>
              <el-col :span="12"><p class="order-title-boxs"><span class="blueBlock"></span><i>修护总业绩({{form.repairAchAmount}})</i></p></el-col>
              <el-col :span="12" class="dates pr16"><div class="flex-row end jishi"><p class="staff-names cur" @click="addStaff('repair')">{{ staffNames}}</p>&nbsp;
              <el-icon name="arrow-down" /></div></el-col>
            </el-row>
            <el-row class="plr16">
              <el-col :span="12" class="itemCol mb10" v-for="item in form.repairAchAmountList" :key="item.staffId">
                <div class="itemCol-name">{{item.staffName}}</div>
                <el-input class="ey" v-model="item.saleTarget" @input="keyUp(item,3)" maxlength="8" placeholder="请输入目标" />
              </el-col>
            </el-row>
          </el-row>
          <el-row class="staff-boxs">
            <el-row>
              <el-col :span="12"><p class="order-title-boxs"><span class="blueBlock"></span><i>其他业绩({{form.otherServeAchAmount}})</i></p></el-col>
              <el-col :span="12" class="dates pr16"><div class="flex-row end jishi"><p class="staff-names cur" @click="addStaff('other')">{{ staffNames}}</p>&nbsp;
              <el-icon name="arrow-down" /></div></el-col>
            </el-row>
            <el-row class="plr16">
              <el-col :span="12" class="itemCol mb10" v-for="item in form.otherServeAchAmountList" :key="item.staffId">
                <div class="itemCol-name">{{item.staffName}}</div>
                <el-input class="ey" v-model="item.saleTarget" @input="keyUp(item,4)" maxlength="8" placeholder="请输入目标" />
              </el-col>
            </el-row>
          </el-row>
          <el-row class="staff-boxs">
            <el-row>
              <el-col :span="12"><p class="order-title-boxs"><span class="blueBlock"></span><i>充值目标({{form.rechargeTargetAmount}})</i></p></el-col>
              <el-col :span="12" class="dates pr16"><div class="flex-row end jishi"><p class="staff-names cur" @click="addStaff('recharge')">{{ staffNames}}</p>&nbsp;
              <el-icon name="arrow-down" /></div></el-col>
            </el-row>
            <el-row class="plr16">
              <el-col :span="12" class="itemCol mb10" v-for="item in form.rechargeTargetAmountList" :key="item.staffId">
                <div class="itemCol-name">{{item.staffName}}</div>
                <el-input class="ey" v-model="item.saleTarget" @input="keyUp(item,4)" maxlength="8" placeholder="请输入目标" />
              </el-col>
            </el-row>
          </el-row>
          <el-row class="staff-boxs">
            <el-row>
              <el-col :span="12"><p class="order-title-boxs"><span class="blueBlock"></span><i>提成目标({{form.commissionTargetAmount}})</i></p></el-col>
              <el-col :span="12" class="dates pr16"><div class="flex-row end jishi"><p class="staff-names cur" @click="addStaff('commission')">{{ staffNames}}</p>&nbsp;
              <el-icon name="arrow-down" /></div></el-col>
            </el-row>
            <el-row class="plr16">
              <el-col :span="12" class="itemCol mb10" v-for="item in form.commissionTargetAmountList" :key="item.staffId">
                <div class="itemCol-name">{{item.staffName}}</div>
                <el-input class="ey" v-model="item.saleTarget" @input="keyUp(item,4)" maxlength="8" placeholder="请输入目标" />
              </el-col>
            </el-row>
          </el-row>
          <el-row class="staff-boxs">
            <el-row>
              <el-col :span="12"><p class="order-title-boxs"><span class="blueBlock"></span><i>泡脚总个数({{form.footTotal}})</i></p></el-col>
              <el-col :span="12" class="dates pr16"><div class="flex-row end jishi"><p class="staff-names cur" @click="addStaff('foot')">{{ staffNames}}</p>&nbsp;
              <el-icon name="arrow-down" /></div></el-col>
            </el-row>
            <el-row class="plr16">
              <el-col :span="12" class="itemCol mb10" v-for="item in form.footTotalList" :key="item.staffId">
                <div class="itemCol-name">{{item.staffName}}</div>
                <el-input class="ey" v-model="item.saleTarget" @input="keyUp(item,5)" maxlength="8" placeholder="请输入目标" />
              </el-col>
            </el-row>
          </el-row>
          <el-row class="staff-boxs">
            <el-row>
              <el-col :span="12"><p class="order-title-boxs"><span class="blueBlock"></span><i>会员总个数({{form.memberTotal}})</i></p></el-col>
              <el-col :span="12" class="dates pr16"><div class="flex-row end jishi"><p class="staff-names cur" @click="addStaff('member')">{{ staffNames}}</p>&nbsp;
              <el-icon name="arrow-down" /></div></el-col>
            </el-row>
            <el-row class="plr16">
              <el-col :span="12" class="itemCol mb10" v-for="item in form.memberTotalList" :key="item.staffId">
                <div class="itemCol-name">{{item.staffName}}</div>
                <el-input class="ey" v-model="item.saleTarget" @input="keyUp(item,6)" maxlength="8" placeholder="请输入目标" />
              </el-col>
            </el-row>
          </el-row>
        </div>
        <div class="drawer-footer pr24 pb10">
          <div class="btns">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </div>
        </div>
      </div>
      
    </drawer>
    <staff-set ref="staffSetForm" @staffChange="changePage"></staff-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import staffSet from "../../components/staff-set";
export default {
  mixins: [minxin],
  components: { drawer ,staffSet},
  data() {
    return {
        addEditTitle: "",
        addEditShow: false,
        form: {},
        shopId: "",
        staffNames: "选择技师",
        tab: "",
        list: []
    };
  },
  mounted () {
    this.editInit();
  },
  methods: {
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
        if (org) {
            this.shopId = this.$store.getters.ShopInfo.shopId;
            this.form.beginTime = this.formatMonth(new Date())
            this.addEditTitle = "配置店员月业绩目标";
            this.$api.get(this.$url.saleTargetStaff.get, { shopId: this.shopId, beginTime: this.form.beginTime }).then(res => {
              if (res) {
                this.form = res;
              }
            })
            .catch(error => {});
        }
        
      });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    },
    addStaff(val) {
        console.log(1);
        this.tab = val;
        let staffIds = []
        this.list = [];
        if (val == 'shop') {
            staffIds = this.form.shopAchAmountList;
            this.list = this.form.shopAchAmountList;
        } else if (val == 'product') {
            staffIds = this.form.productAchAmountList;
            this.list = this.form.productAchAmountList;
        } else if (val == 'repair') {
            staffIds = this.form.repairAchAmountList;
            this.list = this.form.repairAchAmountList;
        } else if (val == 'other') {
            staffIds = this.form.otherServeAchAmountList;
            this.list = this.form.otherServeAchAmountList;
        } else if (val == 'recharge') {
            staffIds = this.form.rechargeTargetAmountList;
            this.list = this.form.rechargeTargetAmountList;
        } else if (val == 'commission') {
            staffIds = this.form.commissionTargetAmountList;
            this.list = this.form.commissionTargetAmountList;
        } else if (val == 'foot') {
            staffIds = this.form.footTotalList;
            this.list = this.form.footTotalList;
        } else if (val == 'member') {
            staffIds = this.form.memberTotalList;
            this.list = this.form.memberTotalList;
        }
        this.$refs["staffSetForm"].$emit("set", {
            staffIds: staffIds
        });
    },
    keyUp (item) {
        if (isNaN(item.saleTarget)) {
          console.log(item);
            item.saleTarget = item.saleTarget.slice(0, item.saleTarget.length - 1);
        }
    },
    onChange (values) {
        console.log(values);
        this.form.dataMonth = values;
        this.getShopList(this.shopId)
    },
    getShopList (id) {
        this.$api.get(this.$url.saleTargetStaff.get, {shopId: id, beginTime: this.form.dataMonth}).then(res => {
            if (res) {
                this.form = res;
                if (this.form.shopAchAmountList == 0) this.flag = true;
                this.form.dataMonth = res.dataMonth;
            }
        });
    },
    changePage(org) {
        if (org.staffIds && this.tab == "shop") {
            this.form.shopAchAmountList = this.digui(this.list, org.staffIds)
        } else if (org.staffIds && this.tab == "product") {
            this.form.productAchAmountList = this.digui(this.list, org.staffIds)
        } else if (org.staffIds && this.tab == "repair") {
            this.form.repairAchAmountList = this.digui(this.list, org.staffIds)
        } else if (org.staffIds && this.tab == "other") {
            this.form.otherServeAchAmountList = this.digui(this.list, org.staffIds)
        } else if (org.staffIds && this.tab == "recharge") {
            this.form.rechargeTargetAmountList = this.digui(this.list, org.staffIds)
        } else if (org.staffIds && this.tab == "commission") {
            this.form.commissionTargetAmountList = this.digui(this.list, org.staffIds)
        } else if (org.staffIds && this.tab == "foot") {
            this.form.footTotalList = this.digui(this.list, org.staffIds)
        } else if (org.staffIds && this.tab == "member") {
            this.form.memberTotalList = this.digui(this.list, org.staffIds)
        }
    },
    digui (old,news) {
        for (let i in old) {
            for (let y in news) {
                if (old[i].staffId == news[y].staffId) {
                    this.$set(news[y], "saleTarget", old[i].saleTarget)
                }
            }
        }   
        return news
    },
    back () {
      this.addEditShow = false;  
    },
    argFunction (arr) {
      let flag = false;
      for (let i = 0; i < arr.length; i++) {
        if (!arr[i].saleTarget) {
            flag = true;
            break;
        }
      }
      return flag
    },
    onSubmit(values) {
        if (this.form.shopAchAmountList.length == 0) {
            return this.$message.error("请分配门店业绩指标")
        } else if (this.form.productAchAmountList.length == 0) {
            return this.$message.error("请分配产品业绩指标")
        } else if (this.form.repairAchAmountList.length == 0) {
            return this.$message.error("请分配修护业绩指标")
        } else if (this.form.otherServeAchAmountList.length == 0) {
            return this.$message.error("请分配其他业绩指标")
        } else if (this.form.rechargeTargetAmountList.length == 0) {
            return this.$message.error("请分配充值目标指标")
        } else if (this.form.commissionTargetAmountList.length == 0) {
            return this.$message.error("请分配提成目标指标")
        } else if (this.form.footTotalList.length == 0) {
            return this.$message.error("请分配泡脚个数指标")
        } else if (this.form.memberTotalList.length == 0) {
            return this.$message.error("请分配新增会员指标")
        }
        let flag = false;
        flag = this.argFunction(this.form.shopAchAmountList);
        console.log(flag);
        if (flag) return this.$message.error("还有店员业绩未分配")
        flag = this.argFunction(this.form.productAchAmountList);
        if (flag) return this.$message.error("还有店员业绩未分配")
        flag = this.argFunction(this.form.repairAchAmountList);
        if (flag) return this.$message.error("还有店员业绩未分配")
        flag = this.argFunction(this.form.otherServeAchAmountList);
        if (flag) return this.$message.error("还有店员业绩未分配")
        flag = this.argFunction(this.form.rechargeTargetAmountList);
        if (flag) return this.$message.error("还有店员业绩未分配")
        flag = this.argFunction(this.form.commissionTargetAmountList);
        if (flag) return this.$message.error("还有店员业绩未分配")
        flag = this.argFunction(this.form.footTotalList);
        if (flag) return this.$message.error("还有店员业绩未分配")
        flag = this.argFunction(this.form.memberTotalList);
        if (flag) return this.$message.error("还有店员业绩未分配")
        let s = this.countNum(this.form.shopAchAmountList, this.form.shopAchAmount)
        let p = this.countNum(this.form.productAchAmountList, this.form.productAchAmount)
        let r = this.countNum(this.form.repairAchAmountList, this.form.repairAchAmount)
        let f = this.countNum(this.form.otherServeAchAmountList, this.form.otherServeAchAmount)
        let t = this.countNum(this.form.footTotalList, this.form.footTotal)
        let m = this.countNum(this.form.memberTotalList, this.form.memberTotal)
        let g = this.countNum(this.form.rechargeTargetAmountList, this.form.rechargeTargetAmount)
        let h = this.countNum(this.form.commissionTargetAmountList, this.form.commissionTargetAmount)

        if (s > 0) {
            return this.$message.error("门店业绩超过门店可配置指标")
        } else if (s < 0) {
            return this.$message.error("门店业绩销售目标未分配完")
        } else if (p > 0) {
            return this.$message.error("产品业绩超过门店可配置指标")
        } else if (p < 0) {
            return this.$message.error("产品业绩销售目标未分配完")
        } else if (r > 0) {
            return this.$message.error("修护业绩超过门店可配置指标")
        } else if (r < 0) {
            return this.$message.error("修护业绩销售目标未分配完")
        } else if (f > 0) {
            return this.$message.error("其他业绩超过门店可配置指标")
        } else if (f < 0) {
            return this.$message.error("其他业绩销售目标未分配完")
        } else if (g > 0) {
            return this.$message.error("充值目标超过门店可配置指标")
        } else if (g < 0) {
            return this.$message.error("充值目标销售目标未分配完")
        } else if (h > 0) {
            return this.$message.error("提成目标超过门店可配置指标")
        } else if (h < 0) {
            return this.$message.error("提成目标销售目标未分配完")
        } else if (t > 0) {
            return this.$message.error("泡脚个数超过门店可配置指标")
        } else if (t < 0) {
            return this.$message.error("泡脚个数销售目标未分配完")
        } else if (m > 0) {
            return this.$message.error("新增会员超过门店可配置指标")
        } else if (m < 0) {
            return this.$message.error("新增会员销售目标未分配完")
        }
        this.$api.post(this.$url.saleTargetStaff.save, this.form).then(res => {
            if (res) {
                this.addEditShow = false;
                this.$message.success("操作成功");
                this.$emit("change", true);
            }
        }).catch(error => {});
    },
    countNum (a,b) {
      let num = 0;
      a.map(item => {
        num += Number(item.saleTarget);
      })
      let c = Math.trunc(num);
      return c - Number(b)
    }
  }
};
</script>
<style scoped lang="less">
.itemCol {
    display: flex;
    align-items: center;
    .itemCol-name {
        width: 70px;
    }
    .ey {
        width: 70%;
    }
}
.months {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}
.dates {
  padding: 30px 0;
}
/deep/ .el-input--small .el-input__inner {
  width: 200px;
  height: 40px;
  line-height: 40px;
}
/deep/ div .el-form-item--small .el-form-item__content,
.el-form-item--small .el-form-item__label {
  line-height: 40px;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 200px;
}
.end {
    justify-content: flex-end;
}

</style>